module.exports = __webpack_public_path__ + "img/icon_pinglun.f44966f7.svg";